// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kh","header":"ki","title":"kj","subheader":"kk","formWrapper":"kl"};